import React from 'react'

interface LogoProps {
  size?: number
}

export default function Logo({ size = 36 }: LogoProps) {
  const scale = size / 48
  return (
    <svg width={240 * scale} height={48 * scale} viewBox="0 0 240 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6,28 L20,10 L34,28 L34,44 Q34,46 32,46 L8,46 Q6,46 6,44 Z" fill="#f0fdf4" stroke="#2D7A3A" strokeWidth="2" strokeLinejoin="round"/>
      <circle cx="20" cy="34" r="5.5" fill="#2D7A3A"/>
      <circle cx="33" cy="13" r="4.5" fill="#2D7A3A"/>
      <text x="46" y="38" fontSize="26" fontWeight="700" fill="#141414" fontFamily="Inter,-apple-system,sans-serif" letterSpacing="-1">Vigilant</text>
    </svg>
  )
}
